class UserConstructorModel {
  constructor({
    guestMode = null,
    newCart = null,
    user_id = null,
    ciam_id = null,
    email_id = null,
    country = null,
    cart_id = null,
  } = {}) {
    this.guestMode = guestMode;
    this.newCart = newCart;
    this.user_id = user_id;
    this.ciam_id = ciam_id;
    this.cart_id = cart_id;
    this.country = country;
    this.email_id = email_id;
  }
  json() {
    return {
      guestMode: this.guestMode,
      newCart: this.newCart,
      user_id: this.user_id,
      ciam_id: this.ciam_id,
      country: this.country,
      cart_id: this.cart_id,
      email_id: this.email_id,
    };
  }
}
module.exports = UserConstructorModel;
